export enum SgeStep {
  IdentityAndPDL,
  Address,
  Consent,
}
